module.exports = __webpack_public_path__ + "img/learning-strategy.8998c5e5.svg";